export const unauthorized = 'Full authentication is required to access this resource';
